import React from "react";
import styled from "styled-components";
import Box from "react-raster";
import { Heading, Paper, Sidebar } from "src/components";
import { Colors } from "src/types";
import { TypographySection } from "./typography";
import { ButtonSection } from "./buttons";
import { CheckboxSection } from "./checkboxes";
import { InputSection } from "./inputs";
import { ModalSection } from "./modals";
import { ListSection } from "./lists";
import { ExtraSection } from "./extras";
import { ToggleSection } from "./toggles";
import { RadioSection } from "./radios";
import { DateSection } from "./date";
import { FileSection } from "./files";
import { CommentSection } from "./comments";
import { theme } from "src/config";
import { CardSection } from "./cards";
import { IconSection } from "./icons";


const StyledPaper = styled(Paper)`
  box-shadow: ${theme.boxShadow.large};
`

export const Components = () => {
  return (
    <StyledPaper style={theme.paper.large}>
      <Box gridRowGap={theme.layout.gutter} alignItems="center">
      <Heading type="h2" color="black">Component library</Heading>
        <CardSection />
        <CommentSection />
        <TypographySection />
        <ButtonSection />
        <Box>
        <Box colspan={[6, 6, 3]} gridColumnGap={theme.layout.gutterSmall}>
          <Box cols={1}>
            <CheckboxSection />
          </Box>
          <Box cols={1}>
            <RadioSection />
          </Box> 
          <Box cols={1}>
            <ToggleSection />
          </Box>
        </Box>
        </Box>
        <Box>
        <DateSection />
        </Box>
        <Box>
          <InputSection />
        </Box>
        <ModalSection />
        <ListSection />
        <FileSection />
        <ExtraSection />
        <IconSection />
      </Box>
    </StyledPaper>
  );
};
